module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0148.jpg?v=fe786ce0";